import React from "react";
import { useParams } from "react-router-dom";

import WebDetail from "../../components/ServicesDetails/WebDetail";
import MobileDetail from "../../components/ServicesDetails/MobileDetail";
import EcommerceDetail from "../../components/ServicesDetails/EcommerceDetail";

const detailComponentBySlug = {
  "developpement-web": WebDetail,
  "applications-web": WebDetail,
  "applications-mobiles": MobileDetail,
  "applications-e-commerce": EcommerceDetail,
};

export default function ServiceDetail() {
  const { slug } = useParams();
  const DetailComponent = detailComponentBySlug[slug];

  if (!DetailComponent) {
    return (
      <div style={{ padding: "3rem", textAlign: "center" }}>
        <h2>Service introuvable</h2>
        <p>Le service demandé n'existe pas.</p>
      </div>
    );
  }

  return <DetailComponent />;
}
